import {deleteErrorMessage, showErrorMessage} from "../../../assessments/CreateAssessmentHelpers";
import l10n from "../../../lang/locallang";

export default class AssessmentSequencePublic {
    view(data) {
        let items = ``;

        if(data.content){
            // randomly reorder the list
            data.content = data.content.sort(() => Math.random() - 0.5);
            for (const [key, value] of Object.entries(data.content)) {
                items += `<li draggable="true" class="sequence__item">
                            <p class="sequence__item-text">${value.value.element}</p>
                        </li>`;
            }
        }
        return `
            <div class="sequence">
                <ul class="sequence__list">
                    ${items}
                </ul>
            </div>`;
    }

    drag() {
        const list = document.querySelector('.sequence__list');

        // Initialize drag events for each item
        const items = list.querySelectorAll('.sequence__item');
        items.forEach(item => {
            item.draggable = true;
            item.addEventListener('dragstart', dragStart);
            item.addEventListener('dragover', dragOver);
            item.addEventListener('dragleave', dragLeave);
            item.addEventListener('drop', drop);
            item.addEventListener('dragend', dragEnd);
        });

        let draggedItem = null;
        let draggedItemIndex = null;
        let oldItemIndex = null;
        let thisIndex = null;
        let oldItem = null;

        function dragStart() {
            draggedItem = this;
            this.classList.add('dragging');
        }

        function dragOver(e) {
            e.preventDefault();
            this.classList.add('dragging-over');
        }

        function dragLeave() {
            this.classList.remove('dragging-over');
        }

        function drop() {
            this.classList.remove('dragging-over');

            oldItem = this;
            oldItem.classList.remove('dragging-over');
            let questionsList = this.closest('.sequence__list');
            const parent = oldItem.parentNode;
            //let oldElement = oldItem.cloneNode(true);
            draggedItemIndex = Array.from(questionsList.children).findIndex(item => item === draggedItem);
            thisIndex = Array.from(questionsList.children).findIndex(item => item === oldItem);
            let totalCount = questionsList.children.length;
            if (draggedItemIndex + 1 === totalCount) {
                // if previously dragged was last element, so just append old element to the end
                parent.appendChild(oldItem);
                //oldItem.remove();
                // and remove dragged item to previous place of old element
                questionsList.insertBefore(draggedItem, questionsList.children[thisIndex]);
            }
            if (draggedItemIndex < thisIndex) {
                // if previously dragged was before current element, so insert old element before current element
                parent.insertBefore(oldItem, draggedItem.nextSibling);
                //oldItem.remove();
                // and remove dragged item to previous place of old element
                questionsList.insertBefore(draggedItem, questionsList.children[thisIndex]);
            }
            if (draggedItemIndex > thisIndex) {
                // if previously dragged was after current element, so insert old element after current element
                parent.insertBefore(oldItem, draggedItem.nextSibling);
                //oldItem.remove();
                // and remove dragged item to previous place of old element
                questionsList.insertBefore(draggedItem, questionsList.children[thisIndex]);
            }
        }

        function dragEnd() {
            this.classList.remove('dragging');
        }
    }

    checkError() {
        let result = true;
        let popup = document.querySelector('#take-assessment-popup');
        const elements_count = popup.querySelectorAll('.sequence__item').length;
        const elements_checked = popup.querySelectorAll('.sequence__item').length;
        const { errorMessage } = l10n.assessmentSequence;

        // if exists error message remove it
        deleteErrorMessage(popup);

        if (elements_checked === 0) {
            showErrorMessage(popup, errorMessage);
            result = false;
        }

        return result;
    }

    addAnswersList() {
        let popup = document.querySelector('#take-assessment-popup');
        let sequence = popup.querySelectorAll('.sequence__item');
        let answer = [];
        // add to data array matching questions and answers
        sequence.forEach(function (item, index) {
            answer[index] = item.querySelector('.sequence__item-text').innerText;
        });
        console.log(answer)
        return answer;
    }

    showResult(data) {
        let popup = document.querySelector('#take-assessment-popup');
        const assessHint = popup.querySelector('.cg-popup__assess-hint');
        const { correctStatus, wrongStatus, correctSequence } = l10n.customCourse;

        assessHint.innerHTML = correctSequence;

        if(data.status){
            if (popup.classList.contains('is-incorrect')) {
                popup.classList.remove('is-incorrect');
            }
            popup.classList.add('is-correct');
            popup.querySelector('.cg-popup__result').innerHTML = `
                <i class="cg-popup__status-icon"></i>
                <p class="cg-popup__status-label">${correctStatus}</p>
            `;

        } else {
            if (popup.classList.contains('is-correct')) {
                popup.classList.remove('is-correct');
            }
            popup.classList.add('is-incorrect');
            popup.querySelector('.cg-popup__result').innerHTML = `
                <i class="cg-popup__status-icon"></i>
                <p class="cg-popup__status-label">${wrongStatus}</p>
            `;
        }

        let items = popup.querySelectorAll('.sequence__item');
        items.forEach(item => {
            item.draggable = false;
        });
        // show wrong and correct answers
        const correctAnswers = data.correctList;
        correctAnswers.forEach(function (item, index) {
            const element = items[index];
            element.querySelector('.sequence__item-text').textContent = item;
        });
    }
}
